// extracted by mini-css-extract-plugin
export default {"label":"label_label__5wwvB","small":"label_small__sOXS4"};